import { Helper } from "../core/util/helper.js";
import { ResourcePlanningSchedulerSettingsPlanningBoardViewModel } from "./resourcePlanningScheduler.js";
import { Config } from "../core/config/config.js";
import { NotificationHelper } from "../core/util/notificationHelper.js";
import { DialogHelper } from "../core/util/dialogHelper.js";
import { HTTPService, JsonResultClass } from "../core/util/httpManager.js";
import { Dialog, DialogProps } from "../core/components/dialog.js";
import { Grid } from "../core/components/grid.js";
import { SheetEventType } from "../../siteManagement/sheet.js";
import { General } from "../../siteManagement/general.js";
import React from "react";
import ReactDOM from "react-dom";

export class Util {


    public static isTodayInSchedulerTimerange = (settingsPlanningBoard: ResourcePlanningSchedulerSettingsPlanningBoardViewModel): boolean => {
        let today = Helper.dates.toDate(settingsPlanningBoard.Today);
        let schedulerStartDate = Helper.dates.toDate(settingsPlanningBoard.Start);
        let schedulerEndDate = Helper.dates.addDays(schedulerStartDate, settingsPlanningBoard.Days - 1);

        return Helper.dates.isDateInBetween(today, schedulerStartDate, schedulerEndDate);
    }

    public static IsSchedulerTimerangeInTheFuture = (settingsPlanningBoard: ResourcePlanningSchedulerSettingsPlanningBoardViewModel): boolean => {
        //let today = Helper.dates.toDate(settingsPlanningBoard.Today);
        //let schedulerStartDate = Helper.dates.toDate(settingsPlanningBoard.Start);
        //let schedulerEndDate = Helper.dates.addDays(schedulerStartDate, settingsPlanningBoard.Days - 1);
        return Helper.dates.compareMultiTypeDates(settingsPlanningBoard.Today, settingsPlanningBoard.Start, true) == -1;
    }

    public static CheckApproval = async (projNr: string, pIndex: string, newStart: Date | string, newEnd: Date | string, newResourceId: string) => {
        if (!Config.settings.approvalProcessActive)
            return true;


        const result = await HTTPService.get<JsonResultClass>("ResourcePlanning/IsResetRequired", {
            projNr: projNr,
            pIndex: pIndex,
            "values[0].key": "StartIst",
            "values[0].value": Helper.dates.getISODateString(newStart),
            "values[1].key": "EndeIst",
            "values[1].value": Helper.dates.getISODateString(newEnd),
            "values[2].key": "RessNr",
            "values[2].value": newResourceId
        }
        );

        if (result.Code > 0) {
            NotificationHelper.showErrorMessage(result.Message);
        } else {
            if (result.Data === true) {
                const isOk = await DialogHelper.confirm(result.Message);
                if (isOk) {
                    const reset = await HTTPService.get<JsonResultClass>("ResourcePlanning/SetApproval?level=0&projNr=" + encodeURIComponent(projNr) + "&pIndex=" + pIndex)
                    NotificationHelper.showSuccessMessage(reset.Message);
                    return reset.Code === 0;
                }
            } else {
                return true;
            }
        }
    }

    public static async CheckForMultipleOccupancies(projNr: string, pIndex: number, newStart: Date | string, newEnd: Date | string, newResourceId: string) {
        const ALLOWED = 0;
        const NOT_ALLOWED = 1;
        const ASK = 2;
        let mode = Config.user.checkMultipleOccupancy;
        if (mode == ALLOWED) {
            return true;
        }
        const options = {
            ProjNr: projNr,
            PIndex: pIndex,
            NewResourceId: newResourceId,
            Start: newStart,
            End: newEnd,
        }

        const result = await HTTPService.post<JsonResultClass<boolean>>("ResourcePlanningScheduler/CheckForMultipleOccupancies", { options: options })
        if (result.Code != 0) {
            NotificationHelper.showErrorMessage(result.Message)
            return false;
        }
        const isMultipleOccupancy = result.Data;
        if (isMultipleOccupancy) {
            switch (mode) {
                case NOT_ALLOWED:
                    NotificationHelper.showInfoMessage(Helper.getTranslation("Regionen.PlantafelEinstellungen.CheckMultipleOccupancy.NoPermitted"));
                    return false;
                case ASK:
                    return await Util.OpenMultipleOccupanciesDialog(result.AdditionalData["assignments"]);
            }
        } else {
            return true;
        }
    }

    private static OpenMultipleOccupanciesDialog = (assignments: any[]) => {
        return new Promise<boolean>((resolve) => {

            const targetElement = $("<div>");
            $("body").append(targetElement);

            const remove_dialog = () => {
                ReactDOM.unmountComponentAtNode(targetElement[0]);
                targetElement[0].remove();
            }

            const onClick = (value: boolean) => {
                remove_dialog();
                resolve(value)
            }

            const root = ReactDOM["createRoot"](targetElement[0]);
            root.render(<MultipleOccupancyDialog assignments={assignments} onButtonClick={onClick} />)
        })
    }
}


interface MultipleOccupancyDialogProps {
    assignments: any[];
    onButtonClick: (value: boolean) => void
}
class MultipleOccupancyDialog extends React.Component<MultipleOccupancyDialogProps, { showGrid: boolean, dialogOpen: boolean }>{

    private STORAGE_KEY = "MultipleOccupancyGridOpen";
    private gridOptions: kendo.ui.GridOptions;
    private dialogProps: DialogProps = {
        title: Helper.getTranslation("Regionen.PlantafelEinstellungen.CheckMultipleOccupancy.DialogText"),
        actions: [
            {
                label: Config.translations.cancel,
                action: () => {
                    this.props.onButtonClick(false);
                },
                primary: false
            }, {
                label: Config.translations.ok,
                action: () => {
                    this.props.onButtonClick(true);
                },
                primary: true
            }
        ],
        width: 750
    };

    constructor(props: MultipleOccupancyDialogProps) {
        super(props)

        this.state = {
            showGrid: Helper.loadDataFromStorage(this.STORAGE_KEY),
            dialogOpen: true
        }
        this.initGridOptions();
    }

    private initGridOptions = () => {
        this.gridOptions = {
            sortable: false,
            pageable: false,
            groupable: false,
            filterable: false,
            selectable: true,
            resizable: true,
            scrollable: true,
            editable: false,
            columns: [
                {
                    field: "Key",
                    title: Helper.getTranslation("Statistik.AssignmentId"),
                    template: (dataItem: any) => {
                        return `<a>${dataItem.ProjNr}/${dataItem.Index}</a>`;
                    }
                },
                {
                    field: "Bemerkung",
                    title: Helper.getTranslation("WebSMS.SLA.Level.Title")
                },
                {
                    field: "Kennwort",
                    title: Helper.getTranslation("Field.Einsatz.kennung")
                },
                {
                    field: "Start",
                    title: Helper.getTranslation("Field.Einsatz.startist"),
                    template: (dataItem: any) => {
                        return `<div>${kendo.toString(kendo.parseDate(dataItem.StartIst), 'g')}</div>`;
                    }
                },
                {
                    field: "Ende",
                    title: Helper.getTranslation("Field.Einsatz.endeist"),
                    template: (dataItem: any) => {
                        return `<div>${kendo.toString(kendo.parseDate(dataItem.EndeIst), 'g')}</div>`;
                    }
                },
            ]
        };
    }

    private toggle = () => {
        const value = !this.state.showGrid;
        Helper.saveDataToStorage(this.STORAGE_KEY, value, false);
        this.setState({ showGrid: value })
    }

    private renderGrid = () => {
        return (
            <div className="flex-container" style={{ display: this.state.showGrid ? "flex" : "none", marginTop: "7px" }}>
                <Grid
                    data={this.props.assignments}
                    options={this.gridOptions}
                    id="MultipleOccupancyGrid"
                    onDataBound={this.onDataBound}
                />
            </div>
        );
    }

    private onDataBound = (event: kendo.ui.GridDataBoundEvent) => {
        const data = event.sender.dataSource.view();
        for (let i = 0; i < data.length; i++) {
            const id: string = data[i].IsGuid;
            const link = event.sender.tbody.find(`tr[data-uid='${data[i].uid}'] a`);
            link.on("click", () => {
                this.openSheet(id);
            });
        }

    }

    private openSheet = (id: string) => {
        this.setState({ dialogOpen: false });
        const sheet = General.Sheet.Manager.createSheetWithUrl(`ResourcePlanning/EditByGuid?isguid=${id}` + "&readOnly=true");
        sheet.bind(SheetEventType.Close, () => {
            this.setState({ dialogOpen: true });
        })
    }

    render() {
        return (
            <Dialog {...this.dialogProps} open={this.state.dialogOpen}>
                <div style={{ display: "flex", flexDirection: "column" }}>
                    <div>
                        <a onClick={this.toggle}>{this.state.showGrid ? Helper.getTranslation("WebSMS.GeneralSettings.Units.ShowLess") : Helper.getTranslation("WebSMS.GeneralSettings.Units.ShowMore")}</a>
                    </div>
                    {this.renderGrid()}
                </div>
            </Dialog>
        );
    }
}

